import * as React from 'react';
import { Path, Svg } from 'react-native-svg';
const EditorListUnorderd = (props) => (<Svg width={props.width ?? 800} height={props.height ?? 800} preserveAspectRatio="xMinYMin" viewBox="-5 -7 24 24" {...props}>
    <Path d="M4 0h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 8h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0-4h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zM1 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" fill={props.color || 'black'}/>
  </Svg>);
export default EditorListUnorderd;
